import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Trophy, Camera, Cpu } from 'lucide-react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

const API_BASE = process.env.REACT_APP_BACKEND_URL;
const MONTHS = ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'];
const medal = ['bg-yellow-400 text-yellow-950', 'bg-gray-300 text-gray-800', 'bg-amber-600 text-white'];

export function TeamRanking({ currentUsername }) {
  const [data, setData] = useState(null);
  const [period, setPeriod] = useState('');
  useEffect(() => {
    const [y, m] = period ? period.split('-') : [];
    const qs = period ? `&year=${y}&month=${m}` : '';
    axios.get(`${API_BASE}/api/team-ranking?token=${localStorage.getItem('token')}${qs}`).then(r => setData(r.data)).catch(() => setData(null));
  }, [period]);
  if (!data) return null;
  const value = `${data.year}-${data.month}`;

  return (
    <div className="bg-white rounded-xl shadow-lg p-4 md:p-6 border border-gray-100" data-testid="team-ranking">
      <div className="flex items-start justify-between gap-2 mb-4">
        <div>
          <h2 className="text-base md:text-lg font-bold text-gray-800 flex items-center gap-2 mb-1"><Trophy className="w-5 h-5 text-yellow-500" />Ekip Sıralaması</h2>
          <p className="text-xs text-gray-500">Toplam puana göre</p>
        </div>
        <Select value={value} onValueChange={setPeriod}>
          <SelectTrigger className="w-36 h-8 text-xs" data-testid="ranking-month-select"><SelectValue /></SelectTrigger>
          <SelectContent>
            {data.months.map(p => (
              <SelectItem key={`${p.year}-${p.month}`} value={`${p.year}-${p.month}`} data-testid={`ranking-month-${p.year}-${p.month}`}>
                {MONTHS[p.month - 1]} {p.year}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
      {data.rows.length === 0 ? <p className="text-sm text-gray-500">Temsilci bulunamadı.</p> : (
        <div className="overflow-x-auto">
          <table className="w-full text-xs sm:text-sm">
            <thead>
              <tr className="text-left text-xs text-gray-500 border-b">
                <th className="py-2 pr-2">#</th>
                <th className="py-2 pr-2">Temsilci</th>
                <th className="py-2 px-1 sm:px-2 text-center"><span className="inline-flex items-center gap-1"><Camera className="w-3.5 h-3.5" /><span className="hidden sm:inline">Kamera</span></span></th>
                <th className="py-2 px-1 sm:px-2 text-center"><span className="inline-flex items-center gap-1"><Cpu className="w-3.5 h-3.5" /><span className="hidden sm:inline">Cihaz</span></span></th>
                <th className="py-2 pl-1 sm:pl-2 text-center">Toplam</th>
                <th className="py-2 pl-1 sm:pl-2 text-right">Puan</th>
              </tr>
            </thead>
            <tbody>
              {data.rows.map((r, i) => (
                <tr key={r.username} className={`border-b last:border-0 ${r.username === currentUsername ? 'bg-blue-50 font-semibold' : ''}`} data-testid={`ranking-row-${r.username}`}>
                  <td className="py-2 pr-2"><span className={`inline-flex w-6 h-6 items-center justify-center rounded-full text-xs font-bold ${medal[i] || 'bg-gray-100 text-gray-600'}`}>{i + 1}</span></td>
                  <td className="py-2 pr-2 truncate max-w-[9rem] sm:max-w-none sm:whitespace-nowrap">{r.full_name}</td>
                  <td className={`py-2 px-1 sm:px-2 text-center ${r.camera >= data.camera_target ? 'text-green-600 font-bold' : ''}`}>{r.camera}<span className="text-gray-400 font-normal">/{data.camera_target}</span></td>
                  <td className={`py-2 px-1 sm:px-2 text-center ${r.device >= data.device_target ? 'text-green-600 font-bold' : ''}`}>{r.device}<span className="text-gray-400 font-normal">/{data.device_target}</span></td>
                  <td className="py-2 pl-1 sm:pl-2 text-center font-bold">{r.total}</td>
                  <td className="py-2 pl-1 sm:pl-2 text-right font-bold text-blue-700 whitespace-nowrap" data-testid={`ranking-points-${r.username}`}>{new Intl.NumberFormat('tr-TR', { maximumFractionDigits: 0 }).format(r.points)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
